import { useDispatch, useSelector } from 'react-redux'
import { setSidebarState } from 'src/store/slices/settingsSlice'
import { RootState } from 'src/store/store'
import { SidebarState } from 'src/types/types'
import { ReactComponent as IconToggleSidebar } from "src/assets/images/arrow-small-left.svg"

const Header = () => {
    const dispatch = useDispatch()
    const { sidebarState, activeSidemenu } = useSelector((state: RootState) => state.settings);

    //> opened -> shrinked -> collapsed -> opened >
    const handleSidebarChange = () => {
        let newSidebarState: SidebarState
        if (window.innerWidth < 768) {
            newSidebarState = sidebarState === 'collapsed' ?
                'mobile' :
                'collapsed'
        } else {
            newSidebarState = sidebarState === 'opened' ?
                'shrinked' :
                sidebarState === 'shrinked' ?
                    'collapsed' :
                    sidebarState === 'collapsed' ?
                        'opened' : 'opened'
        }

        dispatch(setSidebarState(newSidebarState))
    }

    return (
        <header className='header'>
            <div className='hstack gap-3'>
                <button className='btn p-0 toggle-sidebar-btn text-white' onClick={handleSidebarChange}>
                    <IconToggleSidebar />
                </button>
                <div className='text-black fs-5'>{activeSidemenu}</div>
            </div>
        </header>
    )
}

export default Header